export enum Environment {
	Test = 'test',
	Preprod = 'preprod',
	Demo = 'demo',
	Prod = 'prod',
}

export const isGrafanaEnabledEnvironment = (environment?: string): boolean =>
	[Environment.Demo, Environment.Prod].includes(environment as Environment);
